// frontend/src/components/settings/AvatarSelectorForm.tsx

import { useState } from 'react';
import { settingsService } from '../../services/settings.service';
import { AVATAR_OPTIONS } from '../../types/settings.types';

interface AvatarSelectorFormProps {
  userId: string;
  currentStyle: string;
}

export function AvatarSelectorForm({ userId, currentStyle }: AvatarSelectorFormProps) {
  const [selected, setSelected] = useState(currentStyle);
  const [isSaving, setIsSaving] = useState(false);

  async function handleSelect(value: string) {
    setSelected(value);
    setIsSaving(true);
    try {
      await settingsService.updateAvatarStyle(userId, value);
    } catch {
      // sessizce yoksay, kritik değil — kullanıcı tekrar deneyebilir
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <div className="card" style={{ marginBottom: 24 }}>
      <h3 className="parent-section-title">AI Avatar Öğretmen</h3>
      <div className="avatar-selector">
        {AVATAR_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            className={`avatar-option ${selected === opt.value ? 'selected' : ''}`}
            onClick={() => handleSelect(opt.value)}
            disabled={isSaving}
          >
            <div className="avatar-option-icon">{opt.icon}</div>
            <div className="avatar-option-name">{opt.name}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
